import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * This enables pan left and right on horizontal scrollable elements on desktop.
 * Behaves like "swiping" left and right on a horizontal list on mobile
 */
@Directive({
  selector: '[scrollOnDrag]',
})
export class ScrollOnDragDirective implements AfterViewInit {
  private pos = { top: 0, left: 0, x: 0, y: 0 };
  private prevScrollLeft: number;
  private velX: number;
  private element: HTMLElement;
  private children: HTMLElement[];
  private momentumId: number;

  constructor(private elementRef: ElementRef) {}

  public ngAfterViewInit(): void {
    const element = this.elementRef?.nativeElement;
    if (!element) {
      return;
    }
    this.element = this.elementRef.nativeElement;
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.momentumLoop = this.momentumLoop.bind(this);
    this.element.addEventListener('mousedown', this.onMouseDown);
    if (!this.element.children?.length) {
      return;
    }
    this.children = Array.from(this.element.children) as HTMLElement[];
    this.children.forEach(child => {
      this.preventDrag(child);
      // child.style.pointerEvents = 'none';
    });
  }

  private preventDrag(element: HTMLElement): void {
    if (!element) {
      return;
    }
    element.draggable = false;
    if (!element.children?.length) {
      return;
    }
    Array.from(element.children).forEach((child: HTMLElement) =>
      this.preventDrag(child)
    );
  }

  private onMouseDown(e): void {
    this.cancelMomentumTracking();
    this.pos = {
      // The current scroll
      left: this.element.scrollLeft,
      top: this.element.scrollTop,
      // Get the current mouse position
      x: e.clientX,
      y: e.clientY,
    };
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
  }

  private onMouseMove(e): void {
    // How far the mouse has been moved
    const dx = e.clientX - this.pos.x;
    this.prevScrollLeft = this.element.scrollLeft;
    // Scroll the element
    this.element.scrollLeft = this.pos.left - dx;
    this.velX = this.element.scrollLeft - this.prevScrollLeft;
  }

  private onMouseUp(): void {
    if (this.velX !== 0) {
      this.beginMomentumTracking();
    }
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  private beginMomentumTracking(): void {
    this.cancelMomentumTracking();
    this.momentumId = requestAnimationFrame(this.momentumLoop);
  }

  private cancelMomentumTracking(): void {
    cancelAnimationFrame(this.momentumId);
  }

  private momentumLoop(): void {
    this.element.scrollLeft += this.velX;
    this.velX *= 0.97;
    if (Math.abs(this.velX) > 0.5) {
      this.momentumId = requestAnimationFrame(this.momentumLoop);
    } else {
      this.velX = 0;
    }
  }
}
